export default {
	zhuye: 'Beranda',
	qingshururiqi: 'Silahkan masukan tanggal',
	shengdanshibailianxikefu: 'Gagal membuat pesanan, silakan hubungi layanan pelanggan',
	jipiao: 'Tiket Penerbangan',
	tongguo: 'melalui',
	changlvkehao: 'Nomor Frequent Flyer',
	zhongzhuanzai: 'Pemberhentian sementara di ....',
	zhongzhuanshijian: 'Waktu Pemberhentian Sementara',
	kenengxuyaolvxingzhengjian: 'Dokumen Perjalanan/Visa yang diperlukan.',
	xinglitongguo: 'Pemeriksaan bagasi lanjutan',
	jiudian: 'HOTELS',
	lvyoutaopiao: 'Paket Perjalanan',
	dumiyue: 'Go Honeymoon',
	remenyouhui: 'Penawaran Menarik',
	chakanquanbu: 'Lihat semua',
	tebietaopiao: 'Penawaran Spesial',
	lvyouxinxi: 'Informasi Perjalanan',
	gouwuzhongxin: 'Mall',
	hangban: 'Penerbangan',
	chengkeziliao: 'Informasi Penumpang',
	fuyingchanpin: 'Fitur Tambahan',
	queren: 'Konfirmasi',
	fukuan: 'Pembayaran',
	chenggong: 'Berhasil',
	xuanzehangban: 'Penerbangan yang dipilih',
	piaojiaguize: 'Aturan tarif & Keterangan',
	piaojiaguizes: 'Aturan tarif',
	feiwang: 'Penerbangan ke',
	fanhui: 'Kembali',
	xiayibu: 'Berikutnya',
	gengduoxijie: 'Lebih banyak',
	yincangxijie: 'Lebih sedikit',
	gengduo: 'lebih',
	gengshao: 'Kurang',
	genggaihangban: 'Rubah Penerbangan',
	jishangfuwu: 'Layanan dalam penerbangan',
	boyinqi: 'Boeing 777-300ER',
	yihaohangzhan: 'Terminal 1',
	suoyoufeixingshijian: 'Semua waktu penerbangan ditampilkan dalam sistem 24 jam.',
	xinguanfeiyan:
		'Sehubungan dengan perkembangan terkini COVID-19 di berbagai negara, kami menyarankan penumpang transit untuk memeriksa kebijakan bandara terkini di bandara transit Anda, beserta batasan masuk di tujuan akhir sebelum membeli tiket penerbangan.',
	zhongyingbuyizhi:
		'Jika terdapat ketidaksesuaian antara versi bahasa Inggris dan versi bahasa Mandarin mengenai nama tujuan dan maskapai penerbangan, maka versi bahasa Inggris yang akan berlaku.',
	mingzitishi: 'Masukkan nama depan Anda dalam bahasa Inggris seperti yang tertulis di paspor.<br>Misalnya jika nama lengkap Anda adalah:<br>"Kwok Fu Hsing" silakan masukkan "Fu Hsing"<br>"Cheung Pak Chi Cecilia" silakan masukkan "Pak Chi Cecilia"<br>Jangan menggunakan karakter Cina.',
	xingshitishi:
		'Masukkan nama lengkap/nama keluarga dalam bahasa Inggris seperti yang tertulis di paspor.<br> Misalnya jika nama lengkap Anda adalah:<br>"Kwok Fu Hsing" silakan masukkan "Kwok"."Cheung Pak Chi Cecilia" silakan masukkan"Cheung ".<br>Jangan menggunakan karakter Cina.',

	huzhaohaomatishi: 'Nomor paspor Anda diperlukan untuk maskapai ini.',
	yudingchenggong: 'Pemesanan berhasil',
	yudingcankao: 'Referensi Pemesanan',
	yudingshibai: 'Penulisan gagal',
	nindeyudingyiqueren: 'Pemesanan Anda telah dikonfirmasi. Email konfirmasi telah dikirimkan ke ....',
	nindeyudingyishibai: 'Reservasi Anda telah gagal, silakan letakkan pesanan baru',
	ninyekyguanliwodeyuding: 'Anda juga dapat mengatur pemesanan penerbangan Anda di "Pesanan Saya"',
	piaojia: 'Harga tiket',
	gongxianghangsi: 'Bagian Kode',
	caozuotongguo: 'Beroperasi Oleh',
	fanhuitishixinxi: 'Jika Anda meninggalkan halaman ini, pesanan tidak akan disimpan lagi dan harga dapat berubah. Apakah Anda yakin ingin keluar?',
	wuxingli: 'No free luggage allowance',
	xingqi1: 'Senin',
	xingqi2: 'Selasa',
	xingqi3: 'Rabu',
	xingqi4: 'Kamis',
	xingqi5: 'Jumat',
	xingqi6: 'Sabtu',
	xingqi0: 'Minggu',
	fareRules: {
		tuipiao: "Refund",
		gaiqi: "Endorse",
		tuigaishuoming: "Refund and Endorse Instructions",
		qifeiqian: "Before Takeoff",
		qifeihou: "After Takeoff",
		buketuipiao: "Non Refundable Tickets",
		buketuishui: "Non Refundable Tax",
		bukegaiqi: "Cannot Endorse",
		mianfeituipiao: "Free Ticket Refund",
		mianfeituishui: "Free Tax Refund",
		mianfeigaiqi: "Free Endorse",
		tuipiaofei: "Refund Fee",
		tuishuifei: "Refund of Tax Fee",
		gaiqifei: "Endorse Fee",
		quanchengweishiyong: "unused tickets",
		quchengyishiyong: "departure ticket(s) used, cancel return ticket(s)",
		chufahangban: "departure flight",
		huichenghangban: "return flight"
	}
};
